import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

import { SharedModule } from '../shared/shared.module'

import { ToolbarComponent } from './toolbar.component'
import { ToolbarMainNavigationComponent } from './toolbar-main-navigation/toolbar-main-navigation.component'
import { ToolbarBackComponent } from './toolbar-back/toolbar-back.component';
import { ToolbarUserComponent } from './toolbar-user/toolbar-user.component';
import { ToolbarMenuComponent } from './toolbar-menu/toolbar-menu.component';
import { ToolbarMenuItemComponent } from './toolbar-menu-item/toolbar-menu-item.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
  ],
  exports: [
    ToolbarComponent,
    ToolbarMainNavigationComponent,
    ToolbarBackComponent,
    ToolbarUserComponent,
    ToolbarMenuComponent,
    ToolbarMenuItemComponent
  ],
  declarations: [
    ToolbarComponent,
    ToolbarMainNavigationComponent,
    ToolbarBackComponent,
    ToolbarUserComponent,
    ToolbarMenuComponent,
    ToolbarMenuItemComponent,
  ]
})
export class ToolbarModule { }



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/toolbar/toolbar.module.ts